import { useRef, useState, useEffect } from "react";

export function useReveal() {
  const ref = useRef(null);
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const observer = new IntersectionObserver(([e]) => {
      if (e.isIntersecting) { setVisible(true); observer.disconnect(); }
    }, { threshold: 0.08 });
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);
  return [ref, visible];
}

const reducedMotion = () =>
  typeof window !== "undefined" &&
  window.matchMedia?.("(prefers-reduced-motion: reduce)").matches;

/** `still` renders the final state with no inline transform at all — used by
    callers that must not have one, e.g. a child of a horizontal scroller, where
    the entrance translate would overflow the rail and make it scroll vertically. */
export default function Reveal({ children, delay = 0, className = "", still: forceStill = false }) {
  const [ref, visible] = useReveal();
  const still = forceStill || reducedMotion();
  return (
    <div ref={ref} className={className} style={still ? undefined : {
      opacity: visible ? 1 : 0,
      transform: visible ? "translateY(0)" : "translateY(28px)",
      transition: `opacity 0.6s ease ${delay}ms, transform 0.6s ease ${delay}ms`,
    }}>{children}</div>
  );
}
